import { onAuthStateChanged, signOut } from "firebase/auth";
import { ref, watch, computed, reactive } from "vue";
import auth from "./firebaseAuth";
import api from "@/composables/api";
import { useReviewers, useUser } from "@/stores";

export default () => {
  const count = ref(0);
  const double = computed(() => count.value * 2);
  const increment = () => count.value++;

  const scrollToElement = (elementId) => {
    const element = document.getElementById(elementId);
    const topPosition = element.getBoundingClientRect().top + window.scrollY;

    window.scrollTo({
      top: topPosition,
      behavior: "smooth",
    });
  };

  ////////////////////////
  // Table Refresh
  ////////////////////////
  const handleTableRefresh = (resultsPerPage = 10) => {
    const reviewersStore = useReviewers();
    const userStore = useUser();

    const totalPages = Math.ceil(
      reviewersStore.totalReviewerCount / resultsPerPage
    );

    if (userStore.currentPage > totalPages) {
      userStore.currentPage = totalPages;
    }

    if (userStore.currentPage < 1) {
      userStore.currentPage = 1;
    }

    reviewersStore.fetchReviewers(userStore.currentPage, resultsPerPage, true);
  };

  return {
    count,
    double,
    increment,
    scrollToElement,
    handleTableRefresh,
  };
};
